import { render, staticRenderFns } from "./assegno.vue?vue&type=template&id=739f59a4&scoped=true&lang=html"
import script from "./assegno.vue?vue&type=script&lang=js"
export * from "./assegno.vue?vue&type=script&lang=js"
import style0 from "./assegno.vue?vue&type=style&index=0&id=739f59a4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f59a4",
  null
  
)

export default component.exports